<template>
    <el-row justify="space-evenly">
        <el-col :lg="12" :span="24" style="text-align: center; margin-bottom: 40px">
            <el-image :src="require('@/assets/vahtilogo.png')"></el-image>
        </el-col>
    </el-row>
    <el-row justify="space-evenly">
        <el-col :lg="14" :span="24">
            <el-card class="login-card">
                <h1>Vahti Vaatimustenhallintajärjestelmä</h1>
                <p>Tämä on Vahti- järjestelmän kirjautumissivu.</p>
                <p>
                    Vahti on järjestelmä, jota käytetään terveydenhuollon rakennushankkeissa. Vahti ohjaa ja opastaa
                    käyttäjää kirjaamaan toiminnan tiloille aiheuttamat tarpeet eli vaatimukset.
                </p>
                <p>
                    Vahdissa tilanimikkeistö on yhtenäistetty sairaanhoitopiirien käytössä olevien tilanimikkeiden pohjalta
                    ja suunnittelualakohtainen sisältö noudattaa vakiintunutta nimikkeistöä.
                </p>
                <p>
                    Tiedot tallennetaan tietokantaan, mikä mahdollistaa monipuoliset hakutoiminnot sekä raportoinnin ja
                    vertailun.
                </p>
                <p>
                    Vahti-järjestelmän omistaa Suomen sairaalatekniikan yhdistys ry (SSTY ry) Järjestelmän toteutuksesta ja
                    ylläpidosta vastaa DataSund Oy yhteyshenkilönä toimii Jani Saine, DataSund Oy.
                </p>
                <p><b>tuki[ät]vahtihuonekortti.fi</b></p>
                <p><ComLoginButton size="large" :icon="SwitchButton" /></p>
            </el-card>
        </el-col>
    </el-row>
    <el-row justify="space-evenly" style="margin-top: 40px">
        <el-col :lg="14" :span="24">
            <el-card class="login-card">
                <h1>Uusien ominaisuuksien esittely</h1>
                <p>Videoesittelyt Vahtiin keväällä 2025 kehitettyistä uusista ominaisuuksista.</p>
                <p>
                    <el-link 
                        href="https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EYkRX9gqC01Fg48SEhG7EgEB2PC_0HlHLYsZG90Rxt6RrA?e=6OQTVG" 
                        type="success" 
                        underline="always"
                        target="_blank">Edistynyt haku</el-link>
                </p>
                <p>
                    <el-link 
                        href="https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EQ1_h3Y_hlZCqAvnqD14JpoBwYX6AFHf6OOZusif_84QuA?e=KkriZy"
                        type="success" 
                        underline="always"
                        target="_blank">Useamman nimikkeen muokkaus yhdellä kertaa</el-link>
                </p>
                <p>
                    <el-link
                        href="https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EWb1Y76Gbr1Om1WYMfcQdSUB8n3ldV-U7psH68dKQPQcmA?e=F0DKpJ"
                        type="success" 
                        underline="always"
                        target="_blank">Kalustepaketit</el-link>
                </p>
                <p>
                    <el-link 
                        href="https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EY9lWcfZKnlPsbuHufh1CC8BnoWb-qjPjAdoGMctD0Yg5A?e=Z92fCT" 
                        type="success" 
                        underline="always"
                        target="_blank">Liitetiedosto nimikkeeisiin</el-link>
                </p>
                <p>
                    <el-link 
                        href="https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EbxgQg-fefdFtmexyz6ZnFUBafBNuN_zIWbFpQih3XW1oQ?e=cVco59" 
                        type="success" 
                        underline="always"
                        target="_blank">Nimikkeiden kommentointi</el-link>
                </p>
                <p>
                    <el-link 
                        href="https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/Ebf1CT7BqY5EtkPHsVJgO6ABOY5s-deenelRgxtUtrvV7Q?e=f5CWBb"
                        type="success" 
                        underline="always"
                        target="_blank">Liitteet tulosteen mukana zip-paketissa</el-link>
                </p>
            </el-card>
        </el-col>
    </el-row>
</template>

<script setup lang="ts">
import ComLoginButton from "@/components/common/buttons/ComLoginButton.vue"
import { SwitchButton } from '@element-plus/icons-vue'

defineOptions({ name: 'KirjauduView' })
</script>

<style scoped>
.login-card {
    background: #29486a;
    color: white;
}
</style>
